import { useIsMobile } from '@/hooks/useMediaQuery';
import { AppointmentsListMobile } from './AppointmentsListMobile';
import { AppointmentsListDesktop } from './AppointmentsListDesktop';
import type { Appointment } from '../types/appointment.types';

interface AppointmentsListProps {
    appointments: Appointment[];
    isLoading?: boolean;
    onAppointmentClick?: (appointment: Appointment) => void;
    page?: number;
    totalPages?: number;
    onPageChange?: (page: number) => void;
}

export function AppointmentsList({
    appointments,
    isLoading = false,
    onAppointmentClick,
    page = 1,
    totalPages,
    onPageChange,
}: AppointmentsListProps) {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <AppointmentsListMobile
                appointments={appointments}
                isLoading={isLoading}
                onAppointmentClick={onAppointmentClick}
                page={page}
                totalPages={totalPages}
                onPageChange={onPageChange}
            />
        );
    }

    return (
        <AppointmentsListDesktop
            appointments={appointments}
            isLoading={isLoading}
            onAppointmentClick={onAppointmentClick}
            page={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
        />
    );
}
